/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.orch.rpc.BreezeAssistantOrchAuthService
 */

export const getAblyAuthTokenRpc = {
  serviceName: 'com.hubspot.breeze.orch.rpc.BreezeAssistantOrchAuthService',
  rpcName: 'getAblyAuthToken',
  auth: 'app',
  fingerprint: 'dtxlovdbcTSJlNzliZR16TvK6tBQDIWe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};